
const collapsableWidgets = document.querySelectorAll('.widget_text, .widget_nav_menu');

collapsableWidgets.forEach(parent => {
    const clickTarget = parent.querySelector('.widget-title');
    const hideTarget = parent.querySelector('[class^="menu-"], .textwidget');

    if (!clickTarget) {
        return;
    }

    if (!hideTarget) {
        return;
    }

    parent.classList.add('closed')

    clickTarget.addEventListener('click', () => {
        parent.classList.toggle('open');
        parent.classList.toggle('closed');
    })

    hideTarget.style.setProperty('--open-height', `${hideTarget.scrollHeight}px`);

    document.addEventListener('resize', () => {
        hideTarget.style.setProperty('--open-height', `${hideTarget.scrollHeight}px`);
    });
})